import axiosInstance from "../app/axios";
import UserRequestByDateListProps from "../propInterfaces/userRequestListExportProps";
import UserRequestByDateRequestDTO from "../shared/dtos/userRequestListExportRequestDTO";

export const getUserRequestsStatementAdminPanelApi = async ({
  startDate,
  endDate,
  page,
  take,
  bookingId,
  searchText,
  adminId,
  departmentName,
}: UserRequestByDateListProps) => {
  const userRequestListExportRequestDTO: UserRequestByDateRequestDTO = {
    startDate,
    endDate,
    bookingId,
    searchText,
    adminId,
    departmentName,
  };

  const result = await axiosInstance.post(
    `user-request/report/statement/dashboard?page=${page}&take=${take}`,
    userRequestListExportRequestDTO,
  );
  return result.data;
};
